<template>
	<!-- ON BRANCH LOADER -->
  <div class="wrapper" id="app">
  	<Topbar class="topbar"></Topbar>
  	<Header class="header"></Header>
    <router-view class="main"></router-view>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
// const fb = require('./firebaseConfig.js')
import Topbar from './components/Topbar.vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
	components: {Topbar,Header,Footer},
	name: 'App',
	data(){
    	return {
    	}
	},
	mounted(){
		this.$store.dispatch('fetchStaticData')
	}
}
</script>

<style>
/*GOOGLE FONTS*/
/*Montserrat*/
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');
/*Roboto*/
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
/*Comfortaa (close btn)*/
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@700&display=swap');
/*font-family: 'Merriweather', serif;*/
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300&display=swap');
/*Icons*/
@import url('https://fonts.googleapis.com/css2?family=Material+Icons');

/*APP GENERAL CSS*/
#app {
  background-color:#ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size:15px;
}
h1{
	font-size:2em;
	font-weight:500;
	letter-spacing:2px;
	line-height: 1.5;
}
h2{
	font-family: 'Merriweather', serif;
	font-size:36px;
	font-weight:600;
	text-decoration:none;
	margin-top: 5px;
}
h3{
	font-size:1.2em;
	font-weight:600;
	text-decoration:none;
}
p{
	font-family: 'Roboto', 'Montserrat', sans-serif;
	line-height: 1.8;
	/*font-weight:300;*/
}
a{
	text-decoration:none;
	color:inherit;
}
.blGradient{
	background: rgb(16,11,91);
	background: linear-gradient(180deg, rgba(16,11,91,1) 0%, rgba(34,64,122,1) 100%);
}

.blGradientHover:hover{
	background: rgb(7,4,51);
background: linear-gradient(180deg, rgba(7,4,51,1) 0%, rgba(15,40,88,1) 100%);
}

.redGradient{
	background: rgb(255,0,72);
	background: linear-gradient(169deg, rgba(255,0,72,1) 0%, rgba(204,11,66,1) 100%);
}

.redGradient:hover{
	background: rgb(224,2,65);
	background: linear-gradient(169deg, rgba(224,2,65,1) 0%, rgba(166,1,48,1) 100%);
}

.bkGradient{
	background: rgb(57,62,68);
	background: linear-gradient(90deg, rgba(57,62,68,1) 0%, rgba(58,62,66,1) 100%);
}
.bkGradientHover:hover{
	background: rgb(57,62,68);
	background: linear-gradient(90deg, rgba(57,62,68,1) 0%, rgba(58,62,66,1) 100%);
}

/*APP DISPOSITION CSS*/
.wrapper{
	display:flex;
	height:100%;
	flex-flow: row wrap;
}
.wrapper > * {
 	flex: 1 100%;
}
.topbar{
	position:fixed;
	top:0px;
	width:100%;
	z-index:6;
}
.header{
	//position:fixed;
	position:relative;
	top:30px;
	width:100%;
	z-index:5;
}
.main{
	//position:relative;
	//top:110px;
	flex:4;
	order:2;
}

.footer{
	//position:relative;
	//top:110px;
	background:#3c3c3c;
	order:3;
	width:100%;
	z-index:4;
	color:#ffffff;
}

/*BUTTON 1*/
button {
	font-family: 'Roboto', 'Montserrat', sans-serif;
	//font-family: 'Merriweather', serif;
	background: rgb(16,11,91);
	background: linear-gradient(135deg, rgba(16,11,91,1) 0%, rgba(34,64,122,1) 100%);
	/*border: solid 2px #3c3c3c;*/
	border:none;
	color: #ffffff;
	padding: 12px 22px;
	text-align: center;
	text-decoration:none;
	display: inline-block;
	margin: 4px 2px;
	cursor: pointer;
	border-radius: 50px;
	//box-shadow: 0px 2px 2px #1a1a1a;
}
button:hover{
	color:white;
	background: rgb(7,4,51);
	background: linear-gradient(135deg, rgba(7,4,51,1) 0%, rgba(15,40,88,1) 100%);
}
button.active{
	background:#3c3c3c;
	box-shadow: inset 0px 2px 2px #1a1a1a;
}

button.closebtn{
	background:none;
	box-shadow:none;
	font-family: 'Comfortaa', cursive;
	font-size:1.2em;
	color:black;
	padding:0px 0px 2px 4px;
	border-radius:0px;
	float:right;
}

/*CALL TO ACTION*/
	.routerlink{
		text-decoration:none;
		cursor:default;
		flex: 0 0 20.05%;
	}
	.action{
		display:flex;
		//flex:1 1 25%;
		flex-flow:column;
    width :300px;
		background-color:#fbfbfb;
		margin:30px;
		text-align:center;
		border-radius:5px;
		box-shadow: 0px 2px 2px #1a1a1a;
		height:240px;
		-webkit-transition: all .2s ease-out;
		-moz-transition: all .2s ease-out;
		-o-transition: all .2s ease-out;
		transition: all .2s ease-out;
		cursor:pointer;
	}
	.action:hover{
		transform: scale(1.1);
		box-shadow: 10px 10px 5px #1a1a1a;
	}
	.action button{
		opacity:0;
		-webkit-transition: all .2s ease-out;
		-moz-transition: all .2s ease-out;
		-o-transition: all .2s ease-out;
		transition: all .2s ease-out;
	}

	.action:hover button{
		opacity:1;
	}
/*	.action2:hover .sub2 {
		background:#fbfbfb;
	}*/
	.action .title{
		flex:1;
		padding:5px;
	}
	.action .sub{
		flex:4;
		display:flex;
		align-items:center;
		justify-content:center;
		text-align:center;
		background-repeat: no-repeat;
    	background-size: cover;
    	background-position:center;
    	border-radius:0px 0px 5px 5px;
    	align-items:center;
	}
	.action h3{
		color:#3c3c3c;
	}

	/* _________________ */

	.actions{
		padding-bottom:120px;
		display:flex;
		flex-flow:row wrap;
		justify-content:center;
		align-items:center;
	}
	/*.action{
		display:flex;
		//flex:1 1 21%;
		flex-flow:column;
    	width :300px;
		background-color:#fbfbfb;
		margin:30px;
		text-align:center;
		border-radius:5px;
		box-shadow: 0px 2px 2px #1a1a1a;
		height:240px;
	}
	.action .title{
		flex:1;
		padding:5px;
	}
	.action .sub{
		flex:4;
		display:flex;
		align-items:center;
		justify-content:center;
		text-align:center;
		background-repeat: no-repeat;
    	background-size: cover;
    	background-position:center;
    	border-radius:0px 0px 5px 5px;
    	align-items:center;
	}
	.action h3{
		color:#3c3c3c;
	}*/

		/*POUR BANDEAU DES SUBPAGES*/

	.pGo{
		background-image:url(./assets/online.svg);
		background-size:cover;
	}
	.cartegrise > .sub{
		background-image:url(./assets/car.svg);
		background-size:cover;
	}
	.pCarte_grise, .pAutres_immat{
		background-image:url(./assets/cartegrise.jpg);
		background-size:cover;
	}

		/*POUR CALL TO ACTION*/
/*	.cartegrise > .sub, .pCarte_grise, .pAutres_immat{
		background-image:url(./assets/car.svg);
		background-size:contain;
	}*/
	
	.adresse > .sub, .pAdresse{
		background-image:url(./assets/adresse.svg);
		background-size:contain;
	}
	.permis > .sub, .duplicata_permis > .sub, .pDuplicata_permis, .pPremiere_demande{
		background-image:url(./assets/permis.svg);
		background-size:contain;
	}
	.codengo > .sub, .pCodengo{
		background-image:url(./assets/codengo2.png);
		background-size:cover;
	}
	.cession > .sub, .pCession{
		background-image:url(./assets/cession.jpg);
		background-size:cover;
	}
	.duplicata > .sub, .pDuplicata{
		background-image:url(./assets/duplicata.jpg);
		background-size:cover;
	}
	.etranger > .sub, .international > .sub, .pVehicule_etranger, .pInternational{
		background-image:url(./assets/etranger.jpeg);
		background-size:cover;
	}
	.succession > .sub, .suspensions > .sub, .pSuccession, .pMatrimonial, .pSuspensions{
		background-image:url(./assets/successions.jpg);
		background-size:cover;
	}
	.collection > .sub, .pCollection{
		background-image:url(./assets/collection.jpg);
		background-size:cover;
	}
	.autres > .sub{
		background-image:url(./assets/autres.jpg);
		background-size:cover;
	}
	.stages > .sub{
		background-image:url(./assets/stages.png);
		background-size:cover;
	}
	.stages4 > .sub{
		background-image:url(./assets/stages4.png);
		background-size:cover;
	}
	.conformite > .sub{
		background-image:url(./assets/conformite.svg);
		background-size:cover;
	}
	.pStages {
		background-image:url(./assets/stage.jpg);
		background-size:cover;
	}
	.renouvellement > .sub, .pRenouvellement{
		background-image:url(./assets/renouvellement.jpg);
		background-size:cover;
	}
	.premiere_demande > .sub{
		background-image:url(./assets/premiere_demande.png);
		background-size:cover;
	}
	.neph > .sub , .pNeph{
		background-image:url(./assets/neph.jpg);
		background-size:cover;
	}
	.pImmatriculation{
		background-image:url(./assets/cartegrise.jpg);
		background-size:cover;
	}
	.pConduite{
		background-image:url(./assets/neph.jpg);
		background-size:cover;
	}
	.p{
		background:linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4));
	}
	.pEtat_civil{
		background-image:url(./assets/etatcivil.jpg);
		background-size:cover;
	}
	.cni > .sub, .pCarte_identite_passeport{
		background-image:url(./assets/cni_passeport.jpg);
		background-size:cover;
	}
	.photomaton > .sub, .pPhotomaton{
		background-image:url(./assets/photomaton.jpg);
		background-size:cover;
	}

	.devanture{
		background-image:url(./assets/devanture.jpg);
	}
	.agence2{
		background-image:url(./assets/agence2.jpg);
	}
	
	/*
	.photomaton > .sub{
		background-image:url(../assets/photomaton.jpg);
	}
	*/

	/*PAGES CSS*/
	.page_container{
	    background-repeat: no-repeat;
	    background-attachment:fixed;
	}

	.page_hero{
		padding-top:50px;
	}
	.page_hero h1{
		margin-left: auto;
    	margin-right: auto;
    	margin-bottom:50px;
    	width:60%;
		text-align: center;
		color:#ffffff;
	  	text-shadow: 0px 1px 1px white;
	}
	.page_about{
		background-color:#22407a;
		padding-top:40px;
	}
	.page_about p{
		text-align:justify;
		font-size:1em;
		color:#ffffff;
		/*text-shadow: 1px 1px 2px white;
		text-shadow: 0px 1px 1px white;*/
		padding-bottom:20px;
		margin-right:10%;
		margin-left:10%;
	}
	/*SUBPAGES CSS*/
	.subpage_container{
		background:#ffffffdd;
		padding:10px 0px 10px 0px;
	}
	.subpage_container h3,h2{
		margin-left:15%;
		margin-right:15%;
		padding:10px 0px 10px 0px;
		//text-align:center;
		//text-decoration:underline;
	}
	.subpage_container .infos{
		margin:0 auto;
		width:80%;
		//background-color:#ECF0F1;
		//box-shadow: 0px 2px 2px #1a1a1a;
		//box-shadow: 0 0 4px rgba(250,250,250,.2);
		border-radius:3px;
		//padding:20px 10px 20px 10px;
	}
	.subpage_container .documents_param{
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
	}
	#app button.button_cas_part{
		padding:10px 10px 10px 10px;
	}
	.subpage_container .cas_part{
		padding:20px 0px 0px 0px;
		text-align:center;
	}
	.subpage_container .documents{
		display:flex;
		align-items:stretch;
		flex-wrap:wrap;
	}

	.subpage_container .list_documents{
		background-color:#3c3c3c;
		flex:1;
		display:flex;
		flex-direction:column;
		align-items:flex-start;
		justify-content:center;
		//margin-left:50px;
		min-width:400px;
		padding:20px;
	}

	.subpage_container .prix{
		flex:1;
		display:flex;
		flex-flow:column;
		justify-content:space-between;
		align-items:center;
	/*	background-color:#dddddd;
		box-shadow: 0px 2px 2px #1a1a1a;
		border-radius:5px;*/
		padding:50px 20px 20px 20px;
		min-width:300px;
		text-align:center;
		background-color:#ECF0F1;
	}
	.subpage_container .about{
		margin-left:15%;
		margin-right:15%;
		text-align:justify;
		//flex:2;
	/*		background-color:#dddddd;
		box-shadow: 0px 2px 2px #1a1a1a;
		border-radius:5px;*/
		padding:0px 0px 10px 0px;
		//min-width:300px;
	}
	.subpage_container .prix span{
		color:#3c3c3c;
		font-size:3em;
		font-weight:900;
	}

	.subpage_container .list_documents div{
		//background-color:#c3120f;
		//background-color:white;
		//background-image:linear-gradient(to right,white 20%,#efefef);
		//margin:5px;
		color:#ffffff;
	}

	.subpage_container .document{
		display:flex;
		align-items:center;
		justify-content:center;
		//box-shadow: 0px 2px 2px #1a1a1a;
		border-radius:3px;
	}

	.subpage_container .document span{
		//background-color:#dddddd;
		//background-color:white;
		padding:6px;
		border-radius:3px;
	}

	.subpage_container .document p{
		margin:0px 15px 0px 20px;
	}

	/*DIV HOME INFO - HOME - PROCESS CG EN LIGNE*/
	.home_infos button, .services_btns button{
		margin-top: 20px;
		font-size:20px;
/*		background: rgb(255,0,72);
		background: linear-gradient(169deg, rgba(255,0,72,1) 0%, rgba(204,11,66,1) 100%);*/
	}

	.temp{
/*		background: rgb(255,255,255);
		background: linear-gradient(311deg, rgba(255,255,255,1) 0%, rgba(238,234,234,1) 63%, rgba(249,237,237,1) 100%);*/
		background:#fbfbfb;
	}
	.temp1{
		width:100%;
		display:flex;
		text-align:center;
	}
	.subtempImg, .subtempTxt{
		min-height:800px;
		min-width:450px;
		flex:1;
		display:flex;
		justify-content: center;
		padding-bottom:20px 0px 20px 0px;
	}
	.subtempTxt > div{
		padding:10px;
		width:85%;
		margin:auto;
		/*margin-bottom:10px;*/
	}
	.subtempImg div{
		width:70%;
	}
	.subtemph3{
		font-size:5em;
	}
	.home_infos > div{
		display: flex;
		align-items: center;
		justify-content:flex-start;
		background-color: white;
		margin:6px;
		width: 80%;
		border-radius: 5px;
		box-shadow: 1px 1px 1px #1a1a1a;
	}
	.home_infos{
		display: flex;
		flex-flow:row wrap;
		align-items: center;
		justify-content: center;
		flex: 1 0 100%;
	}
	.home_infos span{
		margin: 0px 30px 0px 30px;
	}
	.home_infos p{
		text-align: left;
	}

	/*MEDIA QUERIES*/
	@media all and (max-width: 800px) {
		.service{min-width:200px;flex:1 0 25%};
		.page_hero h1{width:100%;}
		.subpage_container h3{
			text-align:center;
		}
		.subpage_container .documents{
			flex-direction:column
		}
		.subpage_container .prix{
			min-width:auto;
		}
		.subpage_container .list_documents{
			min-width:auto;
			align-items:stretch;
		}
		.subpage_container .document{
			justify-content:flex-start;
		}
		.subpage_container .about{
			min-width:auto;
			margin-left:2.5%;
			margin-right:2.5%;
		}
		.subpage_container .document p{
			margin:0px 10px 0px 10px;
		}
		.subpage_container .infos{
			width:95%;
		}
		.page_about p{
			margin-right:2.5%;
			margin-left:2.5%;
		}
		.home_infos > div{
			flex-direction:column;
			padding-bottom:20px;
		}
		.home_infos span{
		margin: 20px 0px 10px 0px;
	}
	.home_infos p{
		margin:3px;
		text-align:center;
	}

	}
	@media all and (max-width: 1200px) {
		.page_about p{
			margin-right:5%;
			margin-left:5%;
		}
		.subpage_container .prix{
			order:1;
		}
		.subpage_container .list_documents{
			order:3;
		}
		.subpage_container .about{
			margin-left:5%;
			margin-right:5%;
		}
		.subpage_container .documents_param{
			flex-wrap:wrap;
		}
		.subpage_container .document p{
			margin:0px 30px 0px 30px;
		}
		.subpage_container .infos{
			width:90%;
		}
		.home_infos > div{
			padding-right:10px;
			padding-left:10px;
		}
	}

	/*ICONS*/
	@font-face {
	  font-family: 'Material Icons';
	  font-style: normal;
	  font-weight: 400;
	  src: local('Material Icons'),
	    local('MaterialIcons-Regular'),
	}
	.material-icons {
	  font-family: 'Material Icons';
	  font-weight: normal;
	  font-style: normal;
	  font-size: 24px;  /* Preferred icon size */
	  display: inline-block;
	  line-height: 1;
	  text-transform: none;
	  letter-spacing: normal;
	  word-wrap: normal;
	  white-space: nowrap;
	  direction: ltr;

	  /* Support for all WebKit browsers. */
	  -webkit-font-smoothing: antialiased;
	  /* Support for Safari and Chrome. */
	  text-rendering: optimizeLegibility;

	  /* Support for Firefox. */
	  -moz-osx-font-smoothing: grayscale;

	  /* Support for IE. */
	  font-feature-settings: 'liga';
	}
	/* Rules for sizing the icon. */
	.material-icons.md-15 { font-size: 15px; }
	.material-icons.md-18 { font-size: 18px; }
	.material-icons.md-24 { font-size: 24px; }
	.material-icons.md-30 { font-size: 30px; }
	.material-icons.md-36 { font-size: 36px; }
	.material-icons.md-48 { font-size: 48px; }
	.material-icons.md-76 { font-size: 76px; }

	/* Rules for using icons as black on a light background. */
	.material-icons.md-dark { color: rgba(0, 0, 0, 0.54); }
	.material-icons.md-dark.md-inactive { color: rgba(0, 0, 0, 0.26); }
	/* Rules for using icons as white on a dark background. */
	.material-icons.md-light { color: rgba(255, 255, 255, 1); }
	.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
	.material-icons.md-blue {color:#22407a;}
	.material-icons.md-red {color:#c3120f;}
	.material-icons.md-yellow {color:#fed330;}

	.material-icons.shadow {text-shadow: 3px 6px #272634;}


	/*ANIMATIONS*/
	.fade-in {
	animation: fadeIn ease 1s;
	-webkit-animation: fadeIn ease 1s;
	-moz-animation: fadeIn ease 1s;
	-o-animation: fadeIn ease 1s;
	-ms-animation: fadeIn ease 1s;
	}
	@keyframes fadeIn {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-moz-keyframes fadeIn {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-webkit-keyframes fadeIn {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-o-keyframes fadeIn {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-ms-keyframes fadeIn {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	.fade-out {
	animation: fadeOut ease 1s;
	-webkit-animation: fadeOut ease 1s;
	-moz-animation: fadeOut ease 1s;
	-o-animation: fadeOut ease 1s;
	-ms-animation: fadeOut ease 1s;
	}
	@keyframes fadeOut {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-moz-keyframes fadeOut {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-webkit-keyframes fadeOut {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-o-keyframes fadeOut {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-ms-keyframes fadeOut {
	0% {opacity:0;}
	100% {opacity:1;}
	}

	@-moz-keyframes gauge-loader {
  0% {
    -moz-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
  10% {
    -moz-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  20% {
    -moz-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  24% {
    -moz-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  40% {
    -moz-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  54% {
    -moz-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  56% {
    -moz-transform: rotate(78deg);
    transform: rotate(78deg);
  }
  58% {
    -moz-transform: rotate(73deg);
    transform: rotate(73deg);
  }
  60% {
    -moz-transform: rotate(75deg);
    transform: rotate(75deg);
  }
  62% {
    -moz-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  70% {
    -moz-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  80% {
    -moz-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  83% {
    -moz-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  86% {
    -moz-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  89% {
    -moz-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  100% {
    -moz-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
}
@-webkit-keyframes gauge-loader {
  0% {
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
  10% {
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  20% {
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  24% {
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  40% {
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  54% {
    -webkit-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  56% {
    -webkit-transform: rotate(78deg);
    transform: rotate(78deg);
  }
  58% {
    -webkit-transform: rotate(73deg);
    transform: rotate(73deg);
  }
  60% {
    -webkit-transform: rotate(75deg);
    transform: rotate(75deg);
  }
  62% {
    -webkit-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  70% {
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  80% {
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  83% {
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  86% {
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  89% {
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  100% {
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
}
@keyframes gauge-loader {
  0% {
    -moz-transform: rotate(-50deg);
    -ms-transform: rotate(-50deg);
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
  10% {
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  20% {
    -moz-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  24% {
    -moz-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  40% {
    -moz-transform: rotate(-20deg);
    -ms-transform: rotate(-20deg);
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  54% {
    -moz-transform: rotate(70deg);
    -ms-transform: rotate(70deg);
    -webkit-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  56% {
    -moz-transform: rotate(78deg);
    -ms-transform: rotate(78deg);
    -webkit-transform: rotate(78deg);
    transform: rotate(78deg);
  }
  58% {
    -moz-transform: rotate(73deg);
    -ms-transform: rotate(73deg);
    -webkit-transform: rotate(73deg);
    transform: rotate(73deg);
  }
  60% {
    -moz-transform: rotate(75deg);
    -ms-transform: rotate(75deg);
    -webkit-transform: rotate(75deg);
    transform: rotate(75deg);
  }
  62% {
    -moz-transform: rotate(70deg);
    -ms-transform: rotate(70deg);
    -webkit-transform: rotate(70deg);
    transform: rotate(70deg);
  }
  70% {
    -moz-transform: rotate(-20deg);
    -ms-transform: rotate(-20deg);
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
  }
  80% {
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  83% {
    -moz-transform: rotate(25deg);
    -ms-transform: rotate(25deg);
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  86% {
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -webkit-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  89% {
    -moz-transform: rotate(25deg);
    -ms-transform: rotate(25deg);
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  100% {
    -moz-transform: rotate(-50deg);
    -ms-transform: rotate(-50deg);
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
  }
}
/* :not(:required) hides this rule from IE9 and below */
.gauge-loader:not(:required) {
  background: white;
  -moz-border-radius-topleft: 32px;
  -webkit-border-top-left-radius: 32px;
  border-top-left-radius: 32px;
  -moz-border-radius-topright: 32px;
  -webkit-border-top-right-radius: 32px;
  border-top-right-radius: 32px;
  display: inline-block;
  width: 64px;
  height: 32px;
  overflow: hidden;
  position: relative;
  text-indent: -9999px;
}
.gauge-loader:not(:required)::before {
  -moz-animation: gauge-loader 4000ms infinite ease;
  -webkit-animation: gauge-loader 4000ms infinite ease;
  animation: gauge-loader 4000ms infinite ease;
  background: rgba(58,62,66,1);
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  content: '';
  position: absolute;
  left: 30px;
  top: 5.33333px;
  width: 4px;
  height: 26.66667px;
  -moz-transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
}
.gauge-loader:not(:required)::after {
  content: '';
  background: rgba(58,62,66,1);
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  position: absolute;
  left: 25.6px;
  top: 25.6px;
  width: 12.8px;
  height: 12.8px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue